// extracted by mini-css-extract-plugin
export var chip = "_4j-9";
export var chipLabel = "_4j-a";
export var close = "_4j-7";
export var closeIcon = "_4j-8";
export var error = "_4j-6";
export var infoTooltip = "_4j-2";
export var innerContainer = "_4j-1";
export var input = "_4j-b";
export var medium = "_4j-5";
export var outerContainer = "_4j-0";
export var small = "_4j-4";
export var xSmall = "_4j-3";